import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'app-icon-resend',
    templateUrl: './icon-resend.component.html',
    styleUrls: ['./icon-resend.component.scss']
})
export class IconResendComponent implements OnInit {

    @Input() cssClass = '';

    constructor() { }

    ngOnInit() {
    }

}
